import * as types from "./types";

const setUser = (user: any) => ({
  type: types.SET_USER,
  payload: user,
});

const updateProfile = (name: string) => ({
  type: types.UPDATE_PROFILE,
  payload: {
    request: {
      method: "put",
      url: `/users/profiles/${name}`,
    }
  }
});

const fetchOrderInProgress = () => ({
  type: types.FETCH_ORDER_IN_PROGRESS,
  payload: {
    request: {
      method: "get",
      url: "/users/orders/in_progress"
    }
  }
});

const signOut = () => ({
  type: types.SIGN_OUT,
  payload: {
    request: {
      method: "delete",
      url: "/users/sign_out",
    }
  }
});

const verifyUser = (userData: any, csrfToken: string, captchaToken: string) => ({
  type: types.VERIFY_USER,
  payload: {
    request: {
      method: "post",
      url: "/users/verifications",
      data: userData,
      headers: {
        "X-CSRF-TOKEN": csrfToken,
        "CAPTCHA-TOKEN": captchaToken,
      }
    }
  }
});

const signUp = (userData: any, csrfToken: string) => ({
  type: types.SIGN_UP,
  payload: {
    request: {
      method: "post",
      url: "/users",
      data: {
        user: userData
      },
      headers: {
        "X-CSRF-TOKEN": csrfToken
      }
    }
  }
});

const signIn = (userData: any, csrfToken: string) => ({
  type: types.SIGN_IN,
  payload: {
    request: {
      method: "post",
      url: "/users/sign_in",
      data: {
        user: userData
      },
      headers: {
        "X-CSRF-TOKEN": csrfToken
      }
    }
  }
});

const sendOtp = (csrfToken: string, companyId?: number) => ({
  type: types.SEND_OTP,
  payload: {
    request: {
      method: "post",
      url: "/users/otps",
      data: companyId ? { company_id: companyId } : undefined,
      headers: {
        "X-CSRF-TOKEN": csrfToken
      }
    }
  }
});

const sendOtpViaEmail = (payload: any, csrfToken: string, companyId?: number) => ({
  type: types.SEND_OTP,
  payload: {
    request: {
      method: "post",
      url: "/users/otps",
      data: { ...payload, ...(companyId ? { company_id: companyId } : {}) },
      headers: {
        "X-CSRF-TOKEN": csrfToken
      }
    },
  },
});

const resendOtp = (csrfToken: string, companyId?: number) => ({
  type: types.RESEND_OTP,
  payload: {
    request: {
      method: "post",
      url: "/users/otps/resend",
      data: companyId ? { company_id: companyId } : undefined,
      headers: {
        "X-CSRF-TOKEN": csrfToken
      }
    }
  }
});

const resendOtpViaEmail = (payload: any, csrfToken: string, companyId?: number) => ({
  type: types.RESEND_OTP,
  payload: {
    request: {
      method: "post",
      url: "/users/otps/resend",
      data: { ...payload, ...(companyId ? { company_id: companyId } : {}) },
      headers: {
        "X-CSRF-TOKEN": csrfToken
      }
    },
  },
});

const sendOtpForEmailReset = (payload: any, csrfToken: string) => ({
  type: types.SEND_OTP_FOR_EMAIL_RESET,
  payload: {
    request: {
      method: "post",
      url: "/users/otps/send_for_email_reset",
      data: payload,
      headers: {
        "X-CSRF-TOKEN": csrfToken
      }
    },
  },
});

const resendOtpForEmailReset = (payload: any, csrfToken: string) => ({
  type: types.RESEND_OTP_FOR_EMAIL_RESET,
  payload: {
    request: {
      method: "post",
      url: "/users/otps/resend_for_email_reset",
      data: payload,
      headers: {
        "X-CSRF-TOKEN": csrfToken
      }
    },
  },
});

const resetEmail = (
  userData: { email: string; otp: string },
  csrfToken: string
) => ({
  type: types.RESET_EMAIL,
  payload: {
    request: {
      method: "PATCH",
      url: "users/profiles/update_email",
      data: userData,
      headers: {
        "X-CSRF-TOKEN": csrfToken,
      }
    }
  }
});

const updateMarketingConsent = (consent: boolean, csrfToken: string) => ({
  type: types.UPDATE_MARKETING_CONSENT,
  payload: {
    request: {
      method: "PATCH",
      url: "users/profiles/update_marketing_consent",
      data: {
        marketing_consent: consent
      },
      headers: {
        "X-CSRF-TOKEN": csrfToken,
      }
    }
  }
});


export default {
  setUser,
  updateProfile,
  fetchOrderInProgress,
  signOut,
  verifyUser,
  signUp,
  signIn,
  sendOtp,
  resendOtp,
  sendOtpViaEmail,
  resendOtpViaEmail,
  sendOtpForEmailReset,
  resendOtpForEmailReset,
  resetEmail,
  updateMarketingConsent
};
